import React, { useState, useEffect, useRef } from "react";
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Card, CardBody, Table, Row, Col, UncontrolledTooltip, FormGroup, Form } from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import Select from "../../../../../components/Common/custom-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchEmployeeDropdownAutoList,
  fetchEmployees,
  fetchLateConsolidatedReport,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FiRepeat, FiSearch } from "react-icons/fi";
import { FaShare } from "react-icons/fa";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomSelect from "../../../../../components/Common/custom-select";
import Loader from "common/pageLoader";

const data = [
  {
    sno: 1,
    code: "EMP001",
    name: "John Doe",
    category: "Full-Time",
    department: "HR",
    approved: "08:50",
    lateWages: "50.00",
  },
  {
    sno: 2,
    code: "EMP002",
    name: "Jane Smith",
    category: "Part-Time",
    department: "Finance",
    approved: "08:30",
    lateWages: "30.00",
  },
];

const late_approve_status = [
  { value: "1", label: "Pending" },
  { value: "2", label: "Approved" },
  { value: "3", label: "Rejected" },
  { value: "5", label: "Cancelled" },
];

const ShiftLateConsolidatedReport = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    consolidatedReport,
    loading,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    consolidatedReport: state.AttendanceTimeDeductionsReducer?.consolidatedReport,

    loading: state.AttendanceTimeDeductionsReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.AttendanceTimeDeductionsReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
  }));
  const [shiftLateConsolData, setShiftLateConsolData] = useState(data);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  const validationSchema = Yup.object({
    fromDate: Yup.date()
      .typeError("Invalid date")
      .required("Month is required"),

    status: Yup.object()
      .required("Please select a Status"),
  });

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      fromDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      status: "",
      employee: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(
        "cat_id",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "dept_id",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "design_id",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append("month", values.fromDate);
      formData.append("status", values.status?.value);
      formData.append(
        "emp_id",
        values.employee && values.employee.length ? values.employee.map(item => item.value).join(",") : '0'
      );

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchLateConsolidatedReport(formData));
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  const columns = [
    { Header: "S.No", Cell: ({ row }) => consolidatedReport.length - row.index },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Month", accessor: "month" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Nature", accessor: "nature" },
    { Header: "Salary Type", accessor: "salary_type" },
    { Header: "Fixed Gross", accessor: "fixed_gross" },
    { Header: "Full Day Hrs", accessor: "fullDay_hours" },
    { Header: "Total Claimed Hrs", accessor: "total_claimed_hours" },
    { Header: "Available Permission", accessor: "available_permission" },
    { Header: "To be Deduct Hrs", accessor: "to_be_deduct_hours" },
    { Header: "Late Wage", accessor: "late_wage" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Time Deductions" breadcrumbItem="Late Consoldiated Report" />

          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="department">Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                        value={formik.values.department || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="designation">Designation</Label>
                      <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                        value={formik.values.designation || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.designation && formik.errors.designation && (
                        <div className="text-danger">{formik.errors.designation}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Employee Selection */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(emp => ({ value: emp.emp_id, label: emp.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="status">Status <span className="text-danger">*</span></Label>
                      <CustomSelect
                        id="status"
                        name="status"
                        options={late_approve_status}
                        value={formik.values.status || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("status", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.status && formik.errors.status ? 'is-invalid' : ''}
                      />
                      {formik.touched.status && formik.errors.status && (
                        <div className="text-danger">{formik.errors.status}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* From Date */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="fromDate">Month <span className="text-danger">*</span></Label>
                      <CustomMonthPicker
                        name="fromDate"
                        value={formik.values.fromDate}
                        onChange={(date) => formik.setFieldValue("fromDate", date)}
                        onBlur={formik.handleBlur}
                        disableFuture={true}
                        className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.fromDate && formik.errors.fromDate && (
                        <div className="text-danger">{formik.errors.fromDate}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6} sm={12} className="d-flex mob-center align-items-center justify-content-end">
                    <Button type="submit" className="btn button-search me-2">
                      <i className="fas fa-search me-1" /> Search
                    </Button>
                    <Button type="button" className="btn button-export me-2">
                      <i className="fas fa-file-export me-1" /> Export
                    </Button>
                    <Button type="button" onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>


          <Card>
            <CardBody>
              <TableContainer columns={columns} data={consolidatedReport && consolidatedReport.length > 0 ? consolidatedReport : []} isGlobalFilter={true} customPageSize={10} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ShiftLateConsolidatedReport;
